import "./index.css";
import React from "react";

import { ENUM_PERSONAL_SITE } from "BlueratePersonalSite/enum";

export interface TypeStatusProps {
  /**
   * @param status 状态
   */
  status: ENUM_PERSONAL_SITE.STATUS | "COMPLETED";
  style?: React.CSSProperties;
}

const STYLES = {
  COMPLETED: {
    color: "#2e605a",
    background: "#e1f2e2",
    text: "Completed",
  },
  [ENUM_PERSONAL_SITE.STATUS.WAIT]: {
    color: "#9C7000",
    background: "#F8E8D3",
    text: "Verifying",
  },
  [ENUM_PERSONAL_SITE.STATUS.ACTIVATED]: {
    color: "#13358D",
    background: "#D8EAFF",
    text: "Active",
  },
  [ENUM_PERSONAL_SITE.STATUS.DEACTIVATED]: {
    color: "black",
    background: "#DCDCDC",
    text: "Inactive",
  },
};

/**
 * @name Status 流程状态
 */
const Status: React.FC<TypeStatusProps> = ({ status }) => {
  const { text, ...style } = STYLES?.[status] || {};
  return text ? (
    <span className="website-status" style={style}>
      {text}
    </span>
  ) : null;
};

export default Status;
